<main>
    <h2>Actualizar mis datos</h2>
    <div class="form-group">
        <div class="group-input">
          <form class="example-form">
            <mat-form-field class="example-full-width">
              <mat-label>Ingrese su email</mat-label>
              <input type="email" matInput [formControl]="emailFormControl" placeholder="ejemplo@ejemplo.com" [(ngModel)]="email">
              <mat-error *ngIf="emailFormControl.hasError('email') && !emailFormControl.hasError('required')">
                Ingrese un mail valido
              </mat-error>
              <mat-error *ngIf="emailFormControl.hasError('required')">
                Debe ingresar un <strong>email</strong>
              </mat-error>
            </mat-form-field>
          </form>
          <form class="example-form" *ngIf="editMail">
            <mat-form-field class="example-full-width">
              <mat-label>Repita su email</mat-label>
              <input type="email" matInput [formControl]="repemailFormControl" placeholder="ejemplo@ejemplo.com" [(ngModel)]="repEmail">
              <mat-error *ngIf="repemailFormControl.hasError('email') && !repemailFormControl.hasError('required')">
                Ingrese un mail valido
              </mat-error>
              <mat-error *ngIf="repemailFormControl.hasError('required')">
                Debe ingresar un <strong>email</strong>
              </mat-error>
            </mat-form-field>
          </form>
        </div>

        <button mat-raised-button color="primary" (click)="editarMail()" class="edMail" *ngIf="!editMail">Editar mail</button>
        <button mat-raised-button color="primary" (click)="editarPass()" class="edPass" *ngIf="!editPass">Editar contraseña</button>

        <div class="group-input" *ngIf="editPass">
            <form class="example-form">
                <mat-form-field class="example-full-width">
                    <mat-label>Ingrese su contrase&ntilde;a</mat-label>
                    <input type="password" matInput placeholder="********" [(ngModel)]="password" [ngModelOptions]="{standalone: true}">
                </mat-form-field>
            </form>
            <form class="example-form">
                <mat-form-field class="example-full-width">
                    <mat-label>Repita su contrase&ntilde;a</mat-label>
                    <input type="password" matInput placeholder="********" [(ngModel)]="repPassword" [ngModelOptions]="{standalone: true}">
                </mat-form-field>
            </form>
          </div>

          <div *ngIf="editPass">
            <div class="m-bottom-label-contrasena">
              <div class="label-contrasena">
                  La contrase&ntilde;a no permite los siguientes caracteres: &nbsp;<b>=&nbsp;!&nbsp;^&nbsp;'&nbsp;"&nbsp;\&nbsp;<&nbsp;>&nbsp;- </b>
              </div>
          </div>
        </div>

    </div>


    <div class="group-input">
      <form class="example-form">
        <mat-form-field class="example-full-width">
          <mat-label>Ingrese su celular</mat-label>
          <input type="tel" matInput placeholder="11 1111-1111" [(ngModel)]="celular" [ngModelOptions]="{standalone: true}">
        </mat-form-field>
      </form>
      <form class="example-form">
        <mat-form-field class="example-full-width">
          <mat-label>Ingrese su celular</mat-label>
          <input type="tel" matInput placeholder="11 1111-1111" [(ngModel)]="telefono" [ngModelOptions]="{standalone: true}">
        </mat-form-field>
      </form>
    </div>
    <button mat-raised-button color="primary" (click)="setUsuario()">Actualizar perfil</button>

</main>